var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCookiesAnalytic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,7 L23,7 C24.1045695,7 25,7.8954305 25,9 L25,23 C25,24.1045695 24.1045695,25 23,25 L9,25 C7.8954305,25 7,24.1045695 7,23 L7,9 C7,7.8954305 7.8954305,7 9,7 Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#797979",
    x: 15,
    y: 14,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#797979",
    points: "11 16 13 16 13 22 11 22"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#797979",
    x: 19,
    y: 11,
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#797979",
    x: 19,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#797979",
    x: 11,
    y: 12,
    width: 2,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCookiesAnalytic);
export default __webpack_public_path__ + "static/media/ic-cookies-analytic.4f6592d3771be669b4941d726c7dcebf.svg";
export { ForwardRef as ReactComponent };